<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-no-padding">
                <div class="messages" style="margin-top: 0">
                    <div class="message error" :class="{show:messages.error.length > 0}">
                        <i class="fa fa-times" @click="closeMessage('error')"></i>
                        <i class="fa fa-exclamation-circle indicator"></i>
                        <div class="message-inner">
                            <span v-if="messages.error.length == 1" v-html="messages.error[0].message"></span>
                            <ul v-if="messages.error.length > 1">
                                <li v-for="message in messages.error" v-html="message.message"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <LoadingMini ref="loading"></LoadingMini>
                <form class="form">
                    <div class="form-row row">
                        <label class="col-12">{{ $t('plans.form.label') }}</label>
                        <input ref="label" type="text" v-model="label" class="form-input col-12" v-validate
                               data-vv-rules="required" :data-vv-as="$t('plans.form.label')"/>
                        <span class="form-input-error" v-show="showErrors['name'] && errors.has('name')"
                              @click="hideError('name')">{{ errors.first('name') }}</span>
                    </div>
                    <div class="form-row row">
                        <label class="col-12">{{ $t('plans.form.plan') }}</label>
                        <div class="form-input-file full-width" :class="{selected:plan!=''}">
                            <input ref="planInput" v-show="!editMode || editFull" id="plan" type="file" @change="fileSelected"
                                   class="form-input col-12" accept="image/jpg, image/jpeg, image/png"/>
                            <span v-html="$t('plans.form.planFile')"></span>
                            <img ref="planImg" :src="plan"/>
                            <ScaleSelector v-show="scaleDefined" v-model="scale" :width="'50%'"></ScaleSelector>
                        </div>
                    </div>
                    <div class="form-row row" v-show="plan!=''">
                        <label class="col-12">{{ $t('plans.form.scale') }}</label>
                        <div class="col-12 simple-checkbox">
                            <input type="checkbox" name="sameAddress" id="sameAddress" v-model="scaleDefined"
                                   @change="toggleScale"/>
                            <label for="sameAddress">{{ $t('plans.form.setScale') }}</label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <Toolbar class="not-fixed">
            <Btn class="primary" @click.native.stop="valid">
                {{ $t('global.save') }}
            </Btn>
            <Btn @click.native.stop="cancel">
                {{ $t('global.cancel') }}
            </Btn>
        </Toolbar>
    </div>

</template>

<script>
    import Toolbar from '@/components/ui/Toolbar';
    import AddressField from '@/components/ui/fields/AddressField';
    import Btn from "@/components/ui/Button";
    import MiniMap from '@/components/plans/map/MiniMap';
    import ScaleSelector from '@/components/ui/ScaleSelector';
    import LoadingMini from '@/components/ui/LoadingMini';
    import FormUtils from '@/services/form.js';

    export default {
        components: {
            Toolbar,
            Btn,
            MiniMap,
            ScaleSelector,
            LoadingMini
        },
        data () {
            return {
                label: '',
                plan: '',
                obj: null,
                editMode: false,
                editFull: false,
                planHasChanged: false,
                scaleDefined: false,
                scale: 50,
                width: 0,
                showErrors: {
                    name: false
                },
                messages: {
                    success: [],
                    error: [],
                    info: []
                }
            }
        },
        methods: {
            closeMessage: function (type) {
                this.messages[type] = [];
            },
            resetForm: function () {
                this.label = '';
                this.plan = '';
                this.scaleDefined = false;
                this.scale = 50;
                this.width = 0;
            },
            cancel: function () {
                this.resetForm();
                this.$emit('close', 'add', 'plan');
            },
            errorForm: function(error){
                var errorBag = this.$validator.errorBag;
                if (error.response.status == 422) {
                    FormUtils.handleErrors(errorBag, error.response.data.message)
                }
                FormUtils.showAllErrors(this);
                this.$refs.loading.hide();
            },
            hideError: function (key) {
                this.showErrors[key] = false;
            },
            valid: function () {
                this.$refs.loading.show();
                if (this.editMode) {
                    this.obj.name = this.label;
                    if(this.planHasChanged){
                        this.obj.plan.data = this.plan;
                    }
                    else{
                        delete this.obj.plan;
                    }
                    if (this.scaleDefined) {
                        var ratio = this.scale / this.width
                        this.obj.scale = parseFloat(ratio.toFixed(5));
                    }
                    this.$emit('editPlan', this.obj);

                }
                else {

                    if(this.plan == ""){
                        this.messages.error.push({message: 'L\'image du plan est obligatoire', count: 0});
                        this.$refs.loading.hide();
                        return;
                    }


                    var obj = {
                        type: 7,
                        name: this.label,
                        plan: this.plan
                    }
                    if (this.scaleDefined) {
                        var ratio = this.scale / this.width
                        obj.scale = parseFloat(ratio.toFixed(5));
                    }

                    this.$emit('addPlan', obj);
                }
                this.$refs.loading.hide();
                //this.resetForm();
            },
            fileSelected: function (e) {

                var vThis = this;
                var file = e.target.files[0];
                var reader = new FileReader();

                reader.addEventListener("load", function () {
                    vThis.$refs.planImg.onload = function () {
                        vThis.width = this.width;
                    }
                    vThis.plan = reader.result;
                    vThis.planHasChanged = true;
                }, false);

                if (file) {
                    if ((file.size / 1024) / 1024 > 7) {
                        this.messages.error.push({message: 'L\'image du plan ne doit pas dépasser 7Mo', count: 0});
                    }
                    else {
                        reader.readAsDataURL(file);
                    }

                }
            },
            edit: function (edit, obj) {
                var vThis = this;

                this.resetForm();

                if (edit == null) {
                    edit = false;
                }
                this.editFull = false;
                this.editMode = edit;
                if (obj != null) {
                    this.obj = obj;
                    this.label = obj.name;
                    this.plan = obj.plan.data;
                    this.$refs.planImg.onload = function () {
                        vThis.width = this.width;
                        vThis.scaleDefined = true;
                        vThis.scale = parseFloat(obj.scale * this.width);
                        vThis.$refs.planImg.onload = null;
                    }
                    if (obj.scale != null) {
                        if (!obj.hasAPs) {
                            this.editFull = true;
                        }

                    }
                    else {
                        this.width = 0;
                        this.scaleDefined = false;
                        this.scale = 50;
                    }

                }
                if (!edit) {
                    this.$refs.label.focus();
                }
            },
            toggleScale: function () {

            },
            setScale: function () {

            }
        },
        props: ['parent'],
    }
</script>

<style lang="scss" scoped>
    .messages {
        position: initial;
    }
</style>
